<template>
  <div>
    <b-row class="component-margin">
      <b-col>
        <seller-select-modal ref="child" :selectedMemberFromManage="selectedMember" :inboundNumber="inboundNumber" :isInvoicePage="isInvoicePage" :lasNumber="lasNumber" :isRequiredReceipt="isRequiredReceipt" :isInbound="1" :memo="memo" @selected="selectedSeller($event)"></seller-select-modal>
      </b-col>
    </b-row>
    <b-row class="component-margin-half" v-if="memberId == ''">
      <b-col sm="12">
        <inbound-slc-analysis
          :slcAnalysisItems="slcAnalysisItems"
        />
      </b-col>
    </b-row>
    <b-row class="component-margin-half" v-if="memberId !== ''">
      <b-col sm="8">
        <inbound-filter ref="filchild"
          :memberId="memberId"
          :janFilter="janFilter" @changeJanCodeFilter="changeJanCode($event)"
          :nameFilter="nameFilter" @changeNameFilter="changeName($event)"
          :sizeFilter="sizeFilter" @changeSizeFilter="changeSize($event)"
          :statusFilter="statusFilter" @changeShippingFilter="changeStatus($event)"
          :inboundFilter="inboundFilter" @changeInboundFilter="changeInboundFilter($event)"
          @changeFilterInboundDate="changeFilterInboundDate()"
          @updateStartDate="($event) => filterStartDate=$event"
          @updateEndDate="($event) => filterEndDate=$event"
          :displayfilterMore="displayfilterMore"
          @changefilterMore="changefilterMore()"
          :checkfilterInboundDate="checkfilterInboundDate"
          :filterStartDate="filterStartDate" :filterEndDate="filterEndDate"
          @clearFilter="clearFilter" @searchAll="searchAll"
        />
      </b-col>
      <b-col sm="4">
        <to-trouble-product-not-trenai
          :codeFilter="codeFilter" @changeCodeFilter="changeCode($event)"
          :troubleFilter="troubleFilter" @changeTroubleFilter="changeTroubleCode($event)"
          :activeToTrouble="activeToTrouble" :trackingFilter="trackingFilter"
          :troubleMemberFilter="troubleMemberFilter" :locationNumber="locationNumber"
          :troubleFilterOther="troubleFilterOther" @updateTroubleFilterOther="updateTroubleFilterOther($event)"
          :troubleQuantity="troubleQuantity" @updateTroubleQuantity="changeQuantity($event)" 
          :reasonTypeForBarcode="reasonTypeForBarcode"
          :reasonCodeStr="reasonCodeStr"
          @upAdditionalCount="upAdditionalCount()"
          @downAdditionalCount="downAdditionalCount()"
          @clickToTroubleTrenai="saveTroubleTrenai()"
          @updateTrackingFilter="updateTrackingFilter($event)"
          @updateLocationNumber="updateLocationNumber($event)"
          @updateTroubleMemberFilter="updateTroubleMemberFilter($event)"
        />
      </b-col>
    </b-row>
    <b-row class="component-margin" v-if="memberId !== ''">
      <b-col sm="12">
        <inbound-table
          :janFilter="janFilter"
          :items="items"
          :memberId="memberId"
          :nameFilter="nameFilter" :sizeFilter="sizeFilter" :statusFilter="statusFilter" :inboundFilter="inboundFilter"
          :slcAnalysisPointToday="slcAnalysisPointToday" :slcAnalysisPointAll="slcAnalysisPointAll" :moveFromProductMenu="moveFromProductMenu" :authSlcUser="authSlcUser" :authSlcLiteUser="authSlcLiteUser"
          :checkfilterInboundDate="checkfilterInboundDate" :filterStartDate="filterStartDate" :filterEndDate="filterEndDate" :deposit="deposit" 
          @changeTotalRows="updateTotalRows($event)"
          @update="updateRow($event)"
          @toKakoRow="toKakoRow($event)"
          @returnRow="returnRow($event)"
          @deleteRow="deleteRow($event)"
          @deleteRowRecord="deleteRowRecord($event)"
          @resetRequestFix="resetRequestFix($event)"
          @resetRequestFixSimple="resetRequestFixSimple($event)"
          @confirmFixComment="confirmFixComment($event)"
          @hotenRow="hotenRow($event)"
          @lostRow="lostRow($event)"
          @historyRow="historyRow($event)"
          @updateItems="updateItems($event)"
          @outputCsv="outputCsv($event)"
          @outputSetCsv="outputSetCsv($event)"
          @outputPastCsv="outputPastCsv($event)"/>
      </b-col>
    </b-row>
    <b-row class="component-margin" v-if="memberId !== ''">
      <b-col sm="12">
        <inbound-set-table
          :janFilter="janFilter" 
          :items="setItems"
          :setInfo="setManageInfos"
          :memberId="memberId"
          :nameFilter="nameFilter" :sizeFilter="sizeFilter" :statusFilter="statusFilter" :inboundFilter="inboundFilter" :moveFromProductMenu="moveFromProductMenu" :authSlcUser="authSlcUser" :authSlcLiteUser="authSlcLiteUser"
          :checkfilterInboundDate="checkfilterInboundDate" :filterStartDate="filterStartDate" :filterEndDate="filterEndDate"
          @createSet="createSet($event)"
          @changeTotalRows="updateSetTotalRows($event)"
          @update="updateRow($event)"
          @toKakoRow="toKakoRow($event)"
          @returnRow="returnRow($event)"
          @deleteRow="deleteRow($event)"
          @deleteRowRecord="deleteRowRecord($event)"
          @resetRequestFix="resetRequestFix($event)"
          @resetRequestFixSimple="resetRequestFixSimple($event)"
          @confirmFixComment="confirmFixComment($event)"
          @hotenRow="hotenRow($event)"
          @lostRow="lostRow($event)"
          @historyRow="historyRow($event)"
          @updateItems="updateItems($event)"/>
      </b-col>
    </b-row>
    <b-row>
      <b-modal ref="messagePopup" @ok="handleTroblePrintOk" hide-header>
        <div class="text-center">{{confirmMessage}}</div>
      </b-modal>
    </b-row>
    <b-row>
      <b-modal ref="messagePopupSimple" ok-only hide-header>
        <div class="text-center">{{confirmMessageSimple}}</div>
      </b-modal>
    </b-row>
    <b-row>
      <b-modal ref="messagePopupAfterInbound1" @ok="checkToEndInbound" hide-header>
        <div class="text-center">{{confirmMessageSimple}}</div>
      </b-modal>
    </b-row>
    <b-row>
      <b-modal ref="messagePopupComfirmDelete" @ok="deleteRowRecordAction" hide-header>
        <div class="text-center">{{confirmMessageSimple}}</div>
      </b-modal>
    </b-row>
    <b-row>
      <b-modal ref="messagePopupComfirmFix" @ok="resetRequestFixAction" hide-header>
        <div class="text-center">{{confirmMessageSimple}}</div>
      </b-modal>
    </b-row>
    <b-row>
      <b-modal ref="messagePopupComfirmFixSimple" @ok="resetRequestFixSimpleAction" hide-header>
        <div class="text-center">{{confirmMessageSimple}}</div>
      </b-modal>
    </b-row>
    <b-row>
      <b-modal ref="messagePopupFixComment" title="修正依頼コメント" ok-only hide-header>
        <div class="text-center">{{confirmMessageSimple}}</div>
      </b-modal>
    </b-row>
    <b-modal ref="messageWithHeader" :title="popupTitle" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow" hide-header-close hide-footer>
      <div class="text-center">{{confirmMessageSimple}}</div>
      <hr class="modal-divider">
      <div class="right-aligned">
        <b-checkbox size="md" id="memoCheckboxInModal" name="memoCheckboxInModal" v-model="memoCheckboxInModal">チェック済み</b-checkbox>
        <b-button size="md" @click="closeMemoPopup()" :disabled="!memoCheckboxInModal" variant="primary">OK</b-button>
      </div>
    </b-modal>
    <!-- <b-modal ref="messageWithHeader" :title="popupTitle" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" ok-only>
      <div class="text-center">{{confirmMessageSimple}}</div>
    </b-modal> -->
    <inbound-history-modal ref="historyModal"/>
    <b-modal ref="returnModal" title="返品登録" @ok="handleReturnOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="追跡番号" label-class="text-sm-right" label-for="trackingNumberInModal">
        <b-form-input size="sm" id="trackingNumberInModal" v-model="trackingNumberInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="運送会社" label-class="text-sm-right" label-for="carrierInModal">
        <b-select size="sm" id="carrierInModal" v-model="carrierInModal" :options="carrierJapanTypes"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="返品数量" label-class="text-sm-right" label-for="returnQuantityInModal">
        <b-form-input size="sm" id="returnQuantityInModal" v-model="returnQuantityInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="送料" label-class="text-sm-right" label-for="shippingFeeInModal">
        <b-form-input size="sm" id="shippingFeeInModal" v-model="shippingFeeInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="お急ぎ返品" label-class="text-sm-right" label-for="checkboxQuickReturnInModal">
        <b-form-checkbox size="sm" id="checkboxQuickReturnInModal" name="checkboxQuickReturnInModal" v-model="checkboxQuickReturnInModal"></b-form-checkbox>
      </b-form-group>
      <b-form-group size="sm" horizontal label="ラベル剥がし" label-class="text-sm-right" label-for="checkboxRemoveLabelInModal">
        <b-form-checkbox size="sm" id="checkboxRemoveLabelInModal" name="checkboxRemoveLabelInModal" v-model="checkboxRemoveLabelInModal"></b-form-checkbox>
      </b-form-group>
      <b-form-group size="sm" horizontal label="コメント" label-class="text-sm-right" label-for="commentInRetModal">
        <b-form-input size="sm" id="commentInRetModal" v-model="commentInRetModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="諸払更新" label-class="text-sm-right" label-for="checkboxInModal">
        <b-form-checkbox size="sm" id="checkboxInModal" name="checkboxInModal" v-model="checkboxInModal"></b-form-checkbox>
      </b-form-group>
      <b-form-group size="sm" horizontal label="数量移動" label-class="text-sm-right" label-for="checkboxMoveInboundInModal">
        <b-form-checkbox size="sm" id="checkboxMoveInboundInModal" name="checkboxMoveInboundInModal" v-model="checkboxMoveInboundInModal"></b-form-checkbox>
      </b-form-group>
    </b-modal>
    <b-modal ref="deleteModal" title="廃棄登録" @ok="handleDeleteOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="廃棄数量" label-class="text-sm-right" label-for="deleteQuantityInModal">
        <b-form-input size="sm" id="deleteQuantityInModal" v-model="deleteQuantityInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="コメント" label-class="text-sm-right" label-for="commentInDelModal">
        <b-form-input size="sm" id="commentInDelModal" v-model="commentInDelModal" type="text"/>
      </b-form-group>
    </b-modal>
    <!-- <b-modal ref="removeLabelModal" title="ラベル剥がし" @ok="handleRemoveLabelOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="数量" label-class="text-sm-right" label-for="removeLabelQuantityInModal">
        <b-form-input size="sm" id="removeLabelQuantityInModal" v-model="removeLabelQuantityInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="コメント" label-class="text-sm-right" label-for="commentInRemoveLabelModal">
        <b-form-input size="sm" id="commentInRemoveLabelModal" v-model="commentInRemoveLabelModal" type="text"/>
      </b-form-group>
    </b-modal> -->
    <b-modal ref="hotenModal" title="補填登録" @ok="handleHotenOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="数量" label-class="text-sm-right" label-for="hotenQuantityInModal">
        <b-form-input size="sm" id="hotenQuantityInModal" v-model="hotenQuantityInModal" @change="changeHotenQuantity" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="税込" label-class="text-sm-right" label-for="inCustom">
        <b-form-checkbox size="sm" id="inCustom" name="inCustom" v-model="hotenIncustom" @change="changeHotenInCustom"></b-form-checkbox>
      </b-form-group>
      <b-form-group size="sm" horizontal label="金額" label-class="text-sm-right" label-for="hotenAmountInModal">
        <b-form-input size="sm" id="hotenAmountInModal" v-model="hotenAmountInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="コメント" label-class="text-sm-right" label-for="commentInHotenModal">
        <b-form-input size="sm" id="commentInHotenModal" v-model="commentInHotenModal" type="text"/>
      </b-form-group>
    </b-modal>
    <b-modal ref="lostModal" title="不明品登録" @ok="handleLostOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="不明品解除" label-class="text-sm-right" label-for="checkboxInLostModal">
        <b-form-checkbox size="sm" id="checkboxInLostModal" name="checkboxInLostModal" v-model="checkboxInLostModal"></b-form-checkbox>
      </b-form-group>
      <b-form-group size="sm" horizontal label="数量" label-class="text-sm-right" label-for="quantityInLostModal">
        <b-form-input size="sm" id="quantityInLostModal" v-model="quantityInLostModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="コメント" label-class="text-sm-right" label-for="commentInLostModal">
        <b-form-input size="sm" id="commentInLostModal" v-model="commentInLostModal" type="text"/>
      </b-form-group>
    </b-modal>
    <b-modal ref="toKakoModal" title="過去移動登録" @ok="handleToKakoOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="数量" label-class="text-sm-right" label-for="toKakoQuantityInModal">
        <b-form-input size="sm" id="toKakoQuantityInModal" v-model="toKakoQuantityInModal" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="FBA番号" label-class="text-sm-right" label-for="fbaNumberInModal">
        <b-form-input size="sm" id="fbaNumberInModal" v-model="fbaNumberInModal" type="text"/>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import SellerSelectModal from '@/components/common/SellerSelectModal';
import InboundSlcAnalysis from '@/components/inbound/InboundSlcAnalysis';
import ToTroubleTrenai from '@/components/inbound/ToTroubleButtonTrenai';
import InboundFilter from '@/components/inbound/InboundFilter';
import InboundTable from '@/components/inbound/InboundTable';
import InboundSetTable from '@/components/inbound/InboundSetTable';
import InboundHistoryModal from '@/components/inbound/InboundHistoryModal';
import CarrierJapanType from '@/types/CarrierJapanType';
import LocationType from '@/types/LocationType';
import ReasonType from '@/types/ReasonType';
import ShippingType from '@/types/ShippingType';
import * as api from '@/api';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      memberId: '',
      memberIdSimple: '',
      // isMemberId: '0',
      janCode: '',
      janFilter: '',
      nameFilter: '',
      codeFilter: '1',
      troubleFilter: '0',
      sizeFilter: '8',
      statusFilter: '1',
      // statusFilterBoolean: false,
      inboundFilter: '0',
      troubleQuantity: '',
      dispInputTrouble: false,
      lasNumber: '0',
      totalRows: '999',
      totalSetRows: '999',
      isInvoicePage: true,
      notInboundFlag: false,
      authSlcUser: false,
      authSlcLiteUser: false,
      slcAnalysisPointToday: 0,
      slcAnalysisPointAll: 0,
      trackingFilter: '',
      troubleMemberFilter: '',
      locationNumber: '',
      items: [],
      setItems: [],
      slcAnalysisItems: [],
      editItem: {},
      deleteItem: {},
      fixItem: {},
      troubleProductIdInfos: [],
      troubleProductIdInfosNumber: 0,
      requiredSetAsin: false,
      confirmMessage: '',
      confirmMessageSimple: '',
      popupTitle: '',
      headerBgVariant: 'danger',
      headerTextVariant: 'light',
      selectedMember: '',
      activeToTrouble: '0',
      reasonCodeOther: '',
      isRequiredReceipt: '0',
      trackingNumberInModal: '',
      carrierInModal: '',
      returnQuantityInModal: '',
      shippingFeeInModal: '',
      deleteQuantityInModal: '',
      toKakoQuantityInModal: '',
      removeLabelQuantityInModal: '1',
      commentInRemoveLabelModal: '',
      fbaNumberInModal: '',
      commentInRetModal: '',
      commentInDelModal: '',
      checkboxQuickReturnInModal: false,
      checkboxRemoveLabelInModal: false,
      checkboxInModal: true,
      checkboxMoveInboundInModal: true,
      memoCheckboxInModal: false,
      hotenAmountInModal: '',
      hotenQuantityInModal: '',
      quantityInLostModal: '',
      checkboxInLostModal: false,
      commentInLostModal: '',
      hotenIncustom: false,
      commentInHotenModal: '',
      moveFromProductMenu: false,
      isToEndInbound: false,
      isReturnTroubleMenu: false,
      memo: '',
      inboundNumber: '',
      carrierJapanTypes: CarrierJapanType.values(),
      checkfilterInboundDate: false,
      displayfilterMore: false,
      filterStartDate: '',
      filterEndDate: '',
      reasonTypeForBarcode: '',
      reasonCodeStr: '',
      deposit: 0
    };
  },
  created() {
    var account = this.$route.query.account;
    var searchWord = this.$route.query.searchword;
    var _memo = this.$route.query.memo;
    if(account != null){
      this.memberId = account;
      this.moveFromProductMenu = true;
      this.memo = _memo;
      // this.isMemberId = '0';
      api.getInbounds(this.memberId, '', false, (data) => {
        // フィルタの日付指定箇所に処理実行日を登録する。
        var dt = new Date();
        var y = dt.getFullYear();
        var m = ('00' + (dt.getMonth()+1)).slice(-2);
        var d = ('00' + dt.getDate()).slice(-2);
        this.filterStartDate = y + m + d;
        this.filterEndDate = y + m + d;
        this.displayfilterMore = false;
        this.checkfilterInboundDate = false;
        this.memberIdSimple = data.memberIdSimple;
        this.inboundNumber = data.inboundNumber;
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.selectedMember = data.selectedMemberId;
        this.isRequiredReceipt = data.isRequiredReceipt;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.deposit = data.deposit;
        this.nameFilter = searchWord;
        this.authSlcUser = data.authSlcUser;
        this.authSlcLiteUser = data.authSlcLiteUser;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
      })
    } else{
      api.getInboundSlcAnalysis((data) => {
        this.slcAnalysisItems = data.slcAnalysisInfos;
      })
    }
  },
  methods: {
    selectedSeller($event) {
      this.memberId = $event.amazonAccount;
      // this.isMemberId = '0';
      if($event.isRequiredReceipt === '1'){
        this.isRequiredReceipt = '1';
      } else{
        this.isRequiredReceipt = '0';
      }
      this.janCode = '';
      this.janFilter = '';
      this.nameFilter = '';
      this.sizeFilter = '8';
      this.statusFilter = '1';
      this.inboundFilter = '0';
      this.notInboundFlag = false;
      this.codeFilter = '1';
      this.troubleFilter = '0';
      this.activeToTrouble = '0'
      this.trackingFilter = '';
      this.troubleMemberFilter = '';
      this.locationNumber = '';
      this.troubleFilterOther = '';
      this.troubleQuantity = '';
      this.memo = '';
      this.items = [];
      this.setItems = [];
      this.setManageInfos = [];
      api.getInbounds(this.memberId, '', false, (data) => {
        // フィルタの日付指定箇所に処理実行日を登録する。
        var dt = new Date();
        var y = dt.getFullYear();
        var m = ('00' + (dt.getMonth()+1)).slice(-2);
        var d = ('00' + dt.getDate()).slice(-2);
        this.filterStartDate = y + m + d;
        this.filterEndDate = y + m + d;
        this.displayfilterMore = false;
        this.checkfilterInboundDate = false;
        this.memberIdSimple = data.memberIdSimple;
        this.inboundNumber = data.inboundNumber;
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.lasNumber = data.lasNumber;
        this.memo = data.memo;
        this.authSlcUser = data.authSlcUser;
        this.authSlcLiteUser = data.authSlcLiteUser;
        this.deposit = data.deposit;
        if(this.memo !== ''){
          this.popupTitle = '指定会員の注意事項'
          this.confirmMessageSimple = this.memo;
          this.$refs.messageWithHeader.show();
        }
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
      })
    },
    closeMemoPopup(){
      this.$refs.messageWithHeader.hide();
      this.memoCheckboxInModal = false;
    },
    changeFilterInboundDate(){
      // console.log("aaa");
      if(this.checkfilterInboundDate){
        this.checkfilterInboundDate = false;        
      } else{
        this.checkfilterInboundDate = true;
      }
    },
    changefilterMore(){
      if(this.displayfilterMore){
        this.displayfilterMore = false;        
      } else{
        this.displayfilterMore = true;
      }
    },
    clearFilter(){
      this.janFilter = '';
      this.nameFilter = '';
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.getInbounds(this.memberId, '', reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
      })
    },
    searchAll(){
      this.janFilter = '';
      this.nameFilter = '';
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.getSearchAllInbounds(this.memberId, '', reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
      })
    },
    updateRow($event) {
        let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
        api.updateInbounds(this.memberId, this.janFilter, $event, reqKakoList, (data) => {
          this.items = data.items;
          this.setItems = data.setItems;
          this.setManageInfos = data.setProductDetailInfos;
          this.slcAnalysisPointToday = data.slcAnalysisPointToday;
          this.slcAnalysisPointAll = data.slcAnalysisPointAll;
          this.addCellVariant(this.items);
          this.addSetNomalCellVariant(this.setItems);
          // this.janFilter = '';
          if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
            this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
          }
          this.confirmMessageSimple = '登録内容を変更しました。';
          this.$refs.messagePopupSimple.show();
        })
    },
    historyRow(item){
      this.$refs.historyModal.showModal(item);
    },
    returnRow(item){
      this.editItem =  Object.assign({}, this.editItem , item);
      this.$refs.returnModal.show();
    },
    deleteRow(item){
      this.editItem =  Object.assign({}, this.editItem , item);
      this.$refs.deleteModal.show();
    },
    deleteRowRecord(item){
      this.deleteItem = item;
      this.confirmMessageSimple = '削除しますか？';
      this.$refs.messagePopupComfirmDelete.show();
    },
    confirmFixComment(item){
      this.confirmMessageSimple = item.fixComment;
      this.$refs.messagePopupFixComment.show();
    },
    resetRequestFix(item){
      this.fixItem = item;
      this.confirmMessageSimple = '変更削除の設定を解除しますか？';
      this.$refs.messagePopupComfirmFix.show();
    },
    resetRequestFixSimple(item){
      this.fixItem = item;
      this.confirmMessageSimple = '修正依頼の設定を解除しますか？';
      this.$refs.messagePopupComfirmFixSimple.show();
    },
    resetRequestFixAction(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.commisionRecord(this.memberId, this.janFilter, this.fixItem, reqKakoList, '6',(data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '変更削除の設定を解除しました。';
        this.$refs.messagePopupSimple.show();
        this.fixItem = {};
      })
    },
    resetRequestFixSimpleAction(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.commisionRecord(this.memberId, this.janFilter, this.fixItem, reqKakoList, '8',(data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '変更削除の設定を解除しました。';
        this.$refs.messagePopupSimple.show();
        this.fixItem = {};
      })
    },
    deleteRowRecordAction(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.deleteRecord(this.memberId, this.janFilter, this.deleteItem, reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '削除しました。';
        this.$refs.messagePopupSimple.show();
        this.deleteItem = {};
      })
    },
    hotenRow(item){
      this.editItem =  Object.assign({}, this.editItem , item);
      this.$refs.hotenModal.show();
    },
    lostRow(item){
      this.editItem =  Object.assign({}, this.editItem , item);
      this.$refs.lostModal.show();
    },
    toKakoRow(item){
      this.editItem =  Object.assign({}, this.editItem , item);
      this.$refs.toKakoModal.show();
    },
    handleReturnOk(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.returnInbounds(this.memberId, this.janFilter, this.editItem, this.trackingNumberInModal, this.carrierInModal, this.returnQuantityInModal, this.shippingFeeInModal, this.commentInRetModal, this.checkboxInModal, this.checkboxMoveInboundInModal, this.checkboxQuickReturnInModal, this.checkboxRemoveLabelInModal, reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '返品登録完了しました。';
        this.$refs.messagePopupSimple.show();
      })
    },
    changeHotenQuantity(){
      if(this.hotenIncustom){
        this.hotenAmountInModal = Math.floor(this.editItem.purchaseUnitPrice * this.hotenQuantityInModal * 1.1);
      } else{
        this.hotenAmountInModal = this.editItem.purchaseUnitPrice * this.hotenQuantityInModal;
      }
    },
    changeHotenInCustom(){
      if(this.hotenIncustom){
        this.hotenAmountInModal = this.editItem.purchaseUnitPrice * this.hotenQuantityInModal;
      } else{
        this.hotenAmountInModal = Math.floor(this.editItem.purchaseUnitPrice * this.hotenQuantityInModal * 1.1);
      }
    },
    handleDeleteOk(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.deleteInbounds(this.memberId, this.janFilter, this.editItem, this.deleteQuantityInModal, this.commentInDelModal, reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '廃棄登録完了しました。';
        this.$refs.messagePopupSimple.show();
      })
    },
    // handleRemoveLabelOk(){
    //   let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
    //   api.removeLabelInbounds(this.memberId, this.janFilter, this.editItem, this.removeLabelQuantityInModal, this.commentInRemoveLabelModal, reqKakoList, (data) => {
    //     this.items = data.items;
    //     this.setItems = data.setItems;
    //     this.setManageInfos = data.setProductDetailInfos;
    //     this.slcAnalysisPointToday = data.slcAnalysisPointToday;
    //     this.slcAnalysisPointAll = data.slcAnalysisPointAll;
    //     this.addCellVariant(this.items);
    //     this.addSetNomalCellVariant(this.setItems);
    //     if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
    //       this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
    //     }
    //     this.confirmMessageSimple = '諸払登録完了しました。';
    //     this.$refs.messagePopupSimple.show();
    //   })
    // },
    handleHotenOk(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.hotenInbounds(this.memberId, this.janFilter, this.editItem, this.hotenAmountInModal, this.hotenQuantityInModal, this.commentInHotenModal, reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '補填登録完了しました。';
        this.$refs.messagePopupSimple.show();
      })
    },
    handleLostOk(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.lostInbounds(this.memberId, this.editItem.orderId, this.janFilter, reqKakoList, this.quantityInLostModal, this.commentInLostModal, !this.checkboxInLostModal, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '不明品登録完了しました。';
        this.$refs.messagePopupSimple.show();
      })
    },
    handleToKakoOk(){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.toKakoInbounds(this.memberId, this.janFilter, this.editItem, this.toKakoQuantityInModal, this.fbaNumberInModal, reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
        this.confirmMessageSimple = '過去登録完了しました。';
        this.$refs.messagePopupSimple.show();
      })
    },
    updateTrackingFilter($event){
      this.trackingFilter = $event;
    },
    updateTroubleMemberFilter($event){
      this.troubleMemberFilter = $event;
    },
    updateLocationNumber($event){
      this.locationNumber = $event;
    },
    saveTroubleTrenai() {
      // 会員番号の指定が正しいか確認する
      if(this.memberIdSimple !== this.troubleMemberFilter){
        this.confirmMessageSimple = '会員番号の指定が誤っています。';
        this.$refs.messagePopupSimple.show();
        return;
      }
      // 追跡番号が未入力かを確認する
      if(this.trackingFilter === ''){
        this.confirmMessageSimple = '追跡番号が指定されていません。';
        this.$refs.messagePopupSimple.show();
        return;
      }

      var filterWordJan = null;
      var filterWordAsin = null;
      var filterWordName = null;
      if(this.codeFilter === '1'){
        filterWordJan = this.janFilter;
      } else if(this.codeFilter === '2'){
        filterWordAsin = this.nameFilter;
      } else if(this.codeFilter === '3'){
        filterWordName = this.nameFilter;
      } else if(this.codeFilter === '4'){
        filterWordJan = this.janFilter;
        filterWordAsin = this.nameFilter;
      } else if(this.codeFilter === '5'){
        filterWordJan = this.janFilter;
        filterWordName = this.nameFilter;
      } else{
        return;
      }

      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.registerManage(this.memberId, filterWordJan, filterWordAsin, filterWordName, null, this.troubleQuantity, this.troubleFilter, '', this.troubleFilterOther, this.trackingFilter, reqKakoList, this.locationNumber, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.troubleProductIdInfos = data.troubleProductInfos;
        this.troubleProductIdInfosNumber = 0;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        this.troubleMemberFilter = '';
        this.troubleQuantity = '';
        this.trackingFilter = '';
        this.troubleFilterOther = '';
        this.troubleFilter = '0';
        this.janFilter = '';
        this.nameFilter = '';
        this.reasonTypeForBarcode = '';
        this.reasonCodeStr = '';
        // this.changeTroubleCode = '';
        this.handleTroblePrintOk();
        if(this.locationNumber !== ''){
          this.confirmMessageSimple = '商品を【' + this.locationNumber + '】に置いてください';
          this.$refs.messagePopupSimple.show();
        }
      });
    },
    handleTroblePrintOk(){
      // ラベル出力
      let troubleProductIdInfo = this.troubleProductIdInfos[this.troubleProductIdInfosNumber];
      const WinPrint = window.open('', '', 'width=500,height=555,scrollbars=0,menuBar=0,toolbar=0,location=0,status=0');

      let reasonCode = troubleProductIdInfo.reasonCode;
      let reasonName = ReasonType.valueOf(reasonCode).text;
      if(reasonCode === '12'){
        if(troubleProductIdInfo.reasonCodeOther != null && troubleProductIdInfo.reasonCodeOther.length > 35){
          reasonName = reasonName + '（' + troubleProductIdInfo.reasonCodeOther.substr(0, 35) + '）';
        } else{
          reasonName = reasonName + '（' + troubleProductIdInfo.reasonCodeOther + '）';
        }
      }
      let quantity = troubleProductIdInfo.troubleQuantity;
      let troubleId = troubleProductIdInfo.troubleProductId;
      let memberId = troubleProductIdInfo.memberId;
      let trackingNumber = troubleProductIdInfo.trackingNumber;
      if(trackingNumber == null || trackingNumber === ''){
        trackingNumber = '-';
      }
      let url = troubleProductIdInfo.barcodeUrl;
      let locationNumberStr = '-';
      if(this.locationNumber !== ''){
        locationNumberStr = this.locationNumber;
      }
      // LocationType.getLocationTxt(this.locationNumberFilter);

      var printUrl = '<div style="text-align:center"><img src="' + url + '" width="195" height="40" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + troubleId + ' (Localtion: ' + locationNumberStr + ')</div><div style="height:5px;font-size:9px;text-align:center;margin-top:0px;padding:0">[slcuser' + memberId + '/数:' + quantity +'/追跡:' + trackingNumber + ']<br>' + reasonName + '</div>';
      WinPrint.document.body.innerHTML = printUrl;

      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            WinPrint.window.print();
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.close();

            let maxCount = this.troubleProductIdInfos.length;
            this.troubleProductIdInfosNumber = this.troubleProductIdInfosNumber + 1;

            // 処理終了判定
            if(maxCount <= this.troubleProductIdInfosNumber){
              this.troubleProductIdInfo = {};
              // this.confirmMessageSimple = '全ラベル出力完了' ;
              // this.$refs.messagePopupSimple.show();
              return;
            } else{
              this.confirmMessage = '次のラベルを出力します。' ;
              this.$refs.messagePopup.show();
            }
          }, waitSeconds)
        })
      }
      sleep(500);
    },
    changeJanCode($event){
      // console.log("changeJancode: " + $event);
      // if($event === ''){
      //   return;
      // }
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.getInbounds(this.memberId, $event, reqKakoList, (data) => {
        this.items = data.items;
        this.setItems = data.setItems;
        this.setManageInfos = data.setProductDetailInfos;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        this.janFilter = $event;
        // this.nameFilter = '';
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, $event);
        }

        // トレナイ無しボタンの活性状態を更新する
        if(this.troubleFilter === '0' || this.troubleQuantity === ''){
          this.activeToTrouble = '0';
        } else{
          if(this.codeFilter === '1' && this.janFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
          } else if ((this.codeFilter === '2' || this.codeFilter === '3') && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
          } else if ((this.codeFilter === '4' || this.codeFilter === '5') && this.janFilter !== '' && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
          } else{
            this.activeToTrouble = '0';
          }
        }
      })
    },
    createSet($event){
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      var parentAsin = $event['setParentAsin'];
      var isPlus = $event['isPlus']
      // console.log("printStatusOriginal: " + parentAsin + "/" + isPlus);
      api.updatePreparedSetQuantity(this.memberId, this.janFilter, $event, reqKakoList, (data) => {
        // バーコード印刷
        if(isPlus === '1'){
          this.printBarcodeSet($event);
        }
        this.items = data.items;
        this.setItems = data.setItems;
        // this.setManageInfos = data.setProductDetailInfos;
        var setManageInfosWork = data.setProductDetailInfos;
        if(isPlus === '1' && (setManageInfosWork !== null && setManageInfosWork.length > 0)){
          for(let i=0; i< setManageInfosWork.length; i++){
            // console.log("roopAsin-pre: " + setManageInfosWork[i]['setParentAsin']);
            if(setManageInfosWork[i]['setParentAsin'] === parentAsin){
              setManageInfosWork[i]['printStatus'] = true;
            }
            // console.log("roopAsin-aft: " + setManageInfosWork[i]['printStatus']);
          }
        }
        this.setManageInfos = setManageInfosWork;
        this.slcAnalysisPointToday = data.slcAnalysisPointToday;
        this.slcAnalysisPointAll = data.slcAnalysisPointAll;
        this.addCellVariant(this.items);
        this.addSetNomalCellVariant(this.setItems);
        // this.janFilter = $event;
        if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
        }
      })
    },
    changeName($event) {
      // console.log("changeName: " + $event);
      // if($event === ''){
      //   return;
      // }
      if(this.janFilter !== '' && this.codeFilter !== '4' && this.codeFilter !== '5'){
        this.janFilter = '';
        let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
        api.getInbounds(this.memberId, '', reqKakoList, (data) => {
          this.items = data.items;
          this.setItems = data.setItems;
          this.setManageInfos = data.setProductDetailInfos;
          this.slcAnalysisPointToday = data.slcAnalysisPointToday;
          this.slcAnalysisPointAll = data.slcAnalysisPointAll;
          this.addCellVariant(this.items);
          this.addSetNomalCellVariant(this.setItems);
        })
      }

      this.nameFilter = $event;

      // トレナイ無しボタンの活性状態を更新する
      if(this.troubleFilter === '0' || this.troubleQuantity === ''){
        this.activeToTrouble = '0';
      } else{
        if(this.codeFilter === '1' && this.janFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '2' || this.codeFilter === '3') && this.nameFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '4' || this.codeFilter === '5') && this.janFilter !== '' && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
        } else{
          this.activeToTrouble = '0';
        }
      }
    },
    upAdditionalCount(){
      if(this.troubleQuantity === ''){
        this.troubleQuantity = 1;
      } else{
        this.troubleQuantity = parseInt(this.troubleQuantity) + 1;
      }

      // トレナイ無しボタンの活性状態を更新する
      if(this.troubleFilter === '0' || this.troubleQuantity === ''){
        this.activeToTrouble = '0';
      } else{
        if(this.codeFilter === '1' && this.janFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '2' || this.codeFilter === '3') && this.nameFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '4' || this.codeFilter === '5') && this.janFilter !== '' && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
        } else{
          this.activeToTrouble = '0';
        }
      }
    },
    downAdditionalCount(){
      if(this.troubleQuantity !== '' && this.troubleQuantity > '1'){
        this.troubleQuantity = parseInt(this.troubleQuantity) - 1;
      }

      // トレナイ無しボタンの活性状態を更新する
      if(this.troubleFilter === '0' || this.troubleQuantity === ''){
        this.activeToTrouble = '0';
      } else{
        if(this.codeFilter === '1' && this.janFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '2' || this.codeFilter === '3') && this.nameFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '4' || this.codeFilter === '5') && this.janFilter !== '' && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
        } else{
          this.activeToTrouble = '0';
        }
      }
    },
    changeSize($event) {
      this.sizeFilter = $event;
    },
    changeStatus($event) {
      let reqKakoListNow = ShippingType.reqKakoList(this.statusFilter);
      let reqKakoListNew = ShippingType.reqKakoList($event);

      // 追加で過去情報を取得する必要があるか判別
      if(!reqKakoListNow && reqKakoListNew){
          api.getInbounds(this.memberId, '', reqKakoListNew, (data) => {
            this.items = data.items;
            this.setItems = data.setItems;
            this.setManageInfos = data.setProductDetailInfos;
            this.slcAnalysisPointToday = data.slcAnalysisPointToday;
            this.slcAnalysisPointAll = data.slcAnalysisPointAll;
            this.statusFilter = $event;
            this.addCellVariant(this.items);
            this.addSetNomalCellVariant(this.setItems);
        })
      } else{
        this.statusFilter = $event;
      }
    },
    changeInboundFilter($event) {
      this.inboundFilter = $event;
    },
    changeCode($event) {
      this.codeFilter = $event;

      // トレナイ無しボタンの活性状態を更新する
      if(this.troubleFilter === '0' || this.troubleQuantity === ''){
        this.activeToTrouble = '0';
      } else{
        if(this.codeFilter === '1' && this.janFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '2' || this.codeFilter === '3') && this.nameFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '4' || this.codeFilter === '5') && this.janFilter !== '' && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
        } else{
          this.activeToTrouble = '0';
        }
      }
    },
    changeTroubleCode($event){
      this.reasonTypeForBarcode = $event;
      var code = '99';
      if(this.reasonTypeForBarcode === ''){
        return;
      } else if(this.reasonTypeForBarcode === '1'){
        this.troubleFilter = '01';
        this.reasonCodeStr = 'SKU登録無し';
      } else if(this.reasonTypeForBarcode === '2'){
        this.troubleFilter = '02';
        this.reasonCodeStr = 'ASIN無効';
      } else if(this.reasonTypeForBarcode === '3'){
        this.troubleFilter = '04';
        this.reasonCodeStr = 'LAS登録無し';
      } else if(this.reasonTypeForBarcode === '4'){
        this.troubleFilter = '10';
        this.reasonCodeStr = '輸出不可';
      } else if(this.reasonTypeForBarcode === '5'){
        this.troubleFilter = '18';
        this.reasonCodeStr = '商品にJANがありません';
      } else if(this.reasonTypeForBarcode === '6'){
        this.troubleFilter = '19';
        this.reasonCodeStr = '商品JANがスキャン出来ない状態で届きました';
      } else if(this.reasonTypeForBarcode === '7'){
        this.troubleFilter = '20';
        this.reasonCodeStr = '行き先わかれ（商品登録時のバーコードタイプ選択ミス）';
      } else if(this.reasonTypeForBarcode === '8'){
        this.troubleFilter = '21';
        this.reasonCodeStr = '行き先わかれ（納品先が分かれます納品プランを作成して確認してください）';
      } else if(this.reasonTypeForBarcode === '9'){
        this.troubleFilter = '22';
        this.reasonCodeStr = '数量違い';
      } else if(this.reasonTypeForBarcode === '10'){
        this.troubleFilter = '23';
        this.reasonCodeStr = 'FBA納品不可になりました。一度セラセンで納品プランを作成してご確認下さい';
      } else if(this.reasonTypeForBarcode === '11'){
        this.troubleFilter = '25';
        this.reasonCodeStr = '特殊便以外での発送不可';
      } else if(this.reasonTypeForBarcode === '12'){
        this.troubleFilter = '26';
        this.reasonCodeStr = 'バリエーション商品の為';
      } else if(this.reasonTypeForBarcode === '13'){
        this.troubleFilter = '12';
        this.reasonCodeStr = 'その他';
      } else{
        this.confirmMessageSimple = '想定外の番号が入力されました。';
        this.$refs.messagePopupSimple.show();
        this.reasonTypeForBarcode = '';
        this.reasonCodeStr = '';
        this.activeToTrouble = '0';
        return;
      }
      // トレナイ無しボタンの活性状態を更新する
      if(this.troubleFilter === '0' || this.troubleQuantity === ''){
        this.activeToTrouble = '0';
      } else{
        if(this.codeFilter === '1' && this.janFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '2' || this.codeFilter === '3') && this.nameFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '4' || this.codeFilter === '5') && this.janFilter !== '' && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
        } else{
          this.activeToTrouble = '0';
        }
      }
    },
    changeQuantity($event) {
      this.troubleQuantity = $event;

      // トレナイ無しボタンの活性状態を更新する
      if(this.troubleFilter === '0' || this.troubleQuantity === ''){
        this.activeToTrouble = '0';
      } else{
        if(this.codeFilter === '1' && this.janFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '2' || this.codeFilter === '3') && this.nameFilter !== ''){
          if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
            this.activeToTrouble = '0';
          } else{
            this.activeToTrouble = '1';
          }
        } else if ((this.codeFilter === '4' || this.codeFilter === '5') && this.janFilter !== '' && this.nameFilter !== ''){
            if(this.troubleFilter === '12' && this.troubleFilterOther === ''){
              this.activeToTrouble = '0';
            } else{
              this.activeToTrouble = '1';
            }
        } else{
          this.activeToTrouble = '0';
        }
      }
    },
    updateTotalRows($event){
      this.totalRows = $event;
    },
    updateSetTotalRows($event){
      this.totalSetRows = $event;
    },
    updateTroubleFilterOther($event){
      this.troubleFilterOther = $event;
    },
    updateItems($event){
      this.janFilter = '';
      this.nameFilter = '';
      const janInput = this.$refs.filchild.$refs.janFilter; 
      janInput.focus();
      // console.log("AAA: " + $event[0]);
      this.items = $event[0];
      this.setItems = $event[1];
      this.setManageInfos = $event[2];
      this.slcAnalysisPointToday = $event[3];
      this.slcAnalysisPointAll = $event[4];
      this.addCellVariant(this.items);
      this.addSetNomalCellVariant(this.setItems);
      // this.janFilter = '';
      if(this.setManageInfos !== null && this.setManageInfos.length > 0 && this.janFilter != null && this.janFilter !== ''){
          this.addSetCellVariant(this.setManageInfos, this.setItems, this.janFilter);
      }
      this.troubleProductIdInfos = $event[5];
      this.requiredSetAsin = $event[6];
      this.troubleProductIdInfosNumber = 0;
      this.isToEndInbound = $event[7];
      this.isReturnTroubleMenu = $event[8];

      // 集約を促すメッセージ出力
      if(this.requiredSetAsin){
        this.confirmMessageSimple = '集約可能な状態です。セット商品を集約してください。';
        this.$refs.messagePopupAfterInbound1.show();
      } else{
        this.checkToEndInbound();
      }
    },
    checkToEndInbound(){
      if(this.isToEndInbound){
        // 入庫処理を終えて、会員画面を選択するかチェック
        this.isToEndInbound = false;
        this.$refs.child.showModal();
      } else if(this.isReturnTroubleMenu){
        // 入庫処理を終えて、管理品画面に戻るかをチェック
        this.isReturnTroubleMenu = false;
        this.$router.push({path: '/common/merchandise/management', query:{}});
      }
    },
    // セット商品の集約ボタンを押した後のバーコード印刷表示
    printBarcodeSet(item) {
      const WinPrint = window.open('', '', 'width=500,height=555,scrollbars=0,menuBar=0,toolbar=0,location=0,status=0');
      var con = item['productCondition'] === '0' ? 'NEW' : 'USED';
      var pname = item['setParentProductName'].substring(0, 25);
      var printUrl = '';
      var fnsku = item['fnsku'].replace('E', 'e');

            // ラベルに表示する会員番号を成形
      var memberNumber = this.memberId.substr(7);
      var memberNumberOne = this.memberId.substr(7,1);
      if(memberNumberOne.search(/[A-Z]/) >= 0){
        memberNumber = memberNumberOne + '_' + this.memberId.substr(8);
      }

      if(item['matomeStatus']){
        printUrl = '<div style="text-align:center"><img src="' + item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>(' + memberNumber + ') <label style="background-color:black;color:white;border-radius:1rem;padding-left:0.5rem;padding-right:0.5rem">M</label></div>';
      } else{
        printUrl = '<div style="text-align:center"><img src="' + item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>(' + memberNumber + ')</div>';
      }
      WinPrint.document.body.innerHTML = printUrl;

      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            WinPrint.window.print();
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.close();
          }, waitSeconds)
        })
      }
      sleep(500);
    },
    addCellVariant(items) {
      this.hasErrors = false;
      for (const v of items) {
        const errorCells = [];
        if (v['weightType'] === '2') {
          errorCells['purchaseDate'] = 'danger';
          errorCells['productImageUrl'] = 'danger';
          errorCells['productCondition'] = 'danger';
          errorCells['asinSku'] = 'danger';
          errorCells['janCode'] = 'danger';
          errorCells['productNameEn'] = 'danger';
          errorCells['purchaseQuantity'] = 'danger';
          errorCells['price'] = 'danger';
          errorCells['shopName'] = 'danger';
          errorCells['weightInfo'] = 'danger';
          errorCells['forcastShippingCost'] = 'danger';
          errorCells['forcastTargetSales'] = 'danger';
          errorCells['forcastTargetProfit'] = 'danger';
          errorCells['lastPurchaseDate'] = 'danger';
          errorCells['additionalCount'] = 'danger';
          errorCells['inboundQuantity'] = 'danger';
          errorCells['unInboundQuantity'] = 'danger';
          errorCells['status'] = 'danger';
          errorCells['comment'] = 'danger';
          errorCells['additionalFlag'] = 'danger';
          errorCells['matomeStatus'] = 'danger';
          errorCells['label'] = 'danger';
          errorCells['setLabel'] = 'danger';
          errorCells['update'] = 'danger';
          errorCells['trouble'] = 'danger';
          errorCells['history'] = 'danger';
        } else if(v['status'].indexOf('05') !== -1){
          errorCells['purchaseDate'] = 'warning2';
          errorCells['productImageUrl'] = 'warning2';
          errorCells['productCondition'] = 'warning2';
          errorCells['asinSku'] = 'warning2';
          errorCells['janCode'] = 'warning2';
          errorCells['productNameEn'] = 'warning2';
          errorCells['purchaseQuantity'] = 'warning2';
          errorCells['price'] = 'warning2';
          errorCells['shopName'] = 'warning2';
          errorCells['weightInfo'] = 'warning2';
          errorCells['forcastShippingCost'] = 'warning2';
          errorCells['forcastTargetSales'] = 'warning2';
          errorCells['forcastTargetProfit'] = 'warning2';
          errorCells['lastPurchaseDate'] = 'warning2';
          errorCells['additionalCount'] = 'warning2';
          errorCells['inboundQuantity'] = 'warning2';
          errorCells['unInboundQuantity'] = 'warning2';
          errorCells['status'] = 'warning2';
          errorCells['comment'] = 'warning2';
          errorCells['additionalFlag'] = 'warning2';
          errorCells['matomeStatus'] = 'warning2';
          errorCells['label'] = 'warning2';
          errorCells['setLabel'] = 'warning2';
          errorCells['update'] = 'warning2';
          errorCells['trouble'] = 'warning2';
          errorCells['history'] = 'warning2';
        } else if(v['status'] !== ''){
          errorCells['purchaseDate'] = 'primary';
          errorCells['productImageUrl'] = 'primary';
          errorCells['productCondition'] = 'primary';
          errorCells['asinSku'] = 'primary';
          errorCells['janCode'] = 'primary';
          errorCells['productNameEn'] = 'primary';
          errorCells['purchaseQuantity'] = 'primary';
          errorCells['price'] = 'primary';
          errorCells['shopName'] = 'primary';
          errorCells['weightInfo'] = 'primary';
          errorCells['forcastShippingCost'] = 'primary';
          errorCells['forcastTargetSales'] = 'primary';
          errorCells['forcastTargetProfit'] = 'primary';
          errorCells['lastPurchaseDate'] = 'primary';
          errorCells['additionalCount'] = 'primary';
          errorCells['inboundQuantity'] = 'primary';
          errorCells['unInboundQuantity'] = 'primary';
          errorCells['status'] = 'primary';
          errorCells['comment'] = 'primary';
          errorCells['additionalFlag'] = 'primary';
          errorCells['matomeStatus'] = 'primary';
          errorCells['label'] = 'primary';
          errorCells['setLabel'] = 'primary';
          errorCells['update'] = 'primary';
          errorCells['trouble'] = 'primary';
          errorCells['history'] = 'primary';
        }
        v['_cellVariants'] = errorCells;
      }
    },
    addSetNomalCellVariant(items) {
      this.hasErrors = false;
      for (const v of items) {
        const errorCells = [];
        if (v['weightType'] === '2') {
          errorCells['purchaseDate'] = 'danger';
          errorCells['productImageUrl'] = 'danger';
          errorCells['productCondition'] = 'danger';
          errorCells['asinSku'] = 'danger';
          errorCells['productNameEn'] = 'danger';
          errorCells['weightInfo'] = 'danger';
          errorCells['janCode'] = 'danger';
          errorCells['childProductNameJp'] = 'danger';
          errorCells['purchaseInfo'] = 'danger';
          errorCells['price'] = 'danger';
          errorCells['shopName'] = 'danger';
          errorCells['forcastShippingCost'] = 'danger';
          errorCells['forcastTargetSales'] = 'danger';
          errorCells['forcastTargetProfit'] = 'danger';
          errorCells['lastPurchaseDate'] = 'danger';
          errorCells['additionalCount'] = 'danger';
          errorCells['inboundQuantity'] = 'danger';
          errorCells['unInboundQuantity'] = 'danger';
          errorCells['status'] = 'danger';
          errorCells['comment'] = 'danger';
          errorCells['matomeStatus'] = 'danger';
          errorCells['setLabel'] = 'danger';
          errorCells['update'] = 'danger';
          errorCells['trouble'] = 'danger';
          errorCells['history'] = 'danger';
        } else if(v['status'].indexOf('05') !== -1){
          errorCells['purchaseDate'] = 'warning2';
          errorCells['productImageUrl'] = 'warning2';
          errorCells['productCondition'] = 'warning2';
          errorCells['asinSku'] = 'warning2';
          errorCells['productNameEn'] = 'warning2';
          errorCells['weightInfo'] = 'warning2';
          errorCells['janCode'] = 'warning2';
          errorCells['childProductNameJp'] = 'warning2';
          errorCells['purchaseInfo'] = 'warning2';
          errorCells['price'] = 'warning2';
          errorCells['shopName'] = 'warning2';
          errorCells['forcastShippingCost'] = 'warning2';
          errorCells['forcastTargetSales'] = 'warning2';
          errorCells['forcastTargetProfit'] = 'warning2';
          errorCells['lastPurchaseDate'] = 'warning2';
          errorCells['additionalCount'] = 'warning2';
          errorCells['inboundQuantity'] = 'warning2';
          errorCells['unInboundQuantity'] = 'warning2';
          errorCells['status'] = 'warning2';
          errorCells['comment'] = 'warning2';
          errorCells['matomeStatus'] = 'warning2';
          errorCells['setLabel'] = 'warning2';
          errorCells['update'] = 'warning2';
          errorCells['trouble'] = 'warning2';
          errorCells['history'] = 'warning2';
        } else if(v['status'] !== ''){
          errorCells['purchaseDate'] = 'primary';
          errorCells['productImageUrl'] = 'primary';
          errorCells['productCondition'] = 'primary';
          errorCells['asinSku'] = 'primary';
          errorCells['productNameEn'] = 'primary';
          errorCells['weightInfo'] = 'primary';
          errorCells['janCode'] = 'primary';
          errorCells['childProductNameJp'] = 'primary';
          errorCells['purchaseInfo'] = 'primary';
          errorCells['price'] = 'primary';
          errorCells['shopName'] = 'primary';
          errorCells['forcastShippingCost'] = 'primary';
          errorCells['forcastTargetSales'] = 'primary';
          errorCells['forcastTargetProfit'] = 'primary';
          errorCells['lastPurchaseDate'] = 'primary';
          errorCells['additionalCount'] = 'primary';
          errorCells['inboundQuantity'] = 'primary';
          errorCells['unInboundQuantity'] = 'primary';
          errorCells['status'] = 'primary';
          errorCells['comment'] = 'primary';
          errorCells['matomeStatus'] = 'primary';
          errorCells['setLabel'] = 'primary';
          errorCells['update'] = 'primary';
          errorCells['trouble'] = 'primary';
          errorCells['history'] = 'primary';
        }
        v['_cellVariants'] = errorCells;
      }
    },
    addSetCellVariant(items, setItems, $janCode) {
      this.hasErrors = false;
      for (const v of items) {
        const errorCells = [];
        if (v['janCode'].indexOf($janCode) >= 0) {
          errorCells['setParentAsin'] = 'danger';
          errorCells['setParentProductName'] = 'danger';
          errorCells['janCode'] = 'danger';
          errorCells['cproductNameJp'] = 'danger';
          errorCells['cquantityPerSet'] = 'danger';
          errorCells['preparedSetQuantity'] = 'danger';
          errorCells['remainSetQuantity'] = 'danger';
          errorCells['pairFinalAbleSetQuantity'] = 'danger';
          errorCells['additionalCountForSet'] = 'danger';
          errorCells['createSet'] = 'danger';
          errorCells['createSetMinus'] = 'danger';
          errorCells['printSetLabel'] = 'danger';
        }
        if (v['pairFinalAbleSetQuantity'] > 0) {
          errorCells['pairFinalAbleSetQuantity'] = 'dark';
        }
        v['_cellVariants'] = errorCells;
      }
      for (const vv of setItems) {
        const errorCells2 = [];
        if (vv['janCode'].indexOf($janCode) >= 0) {
          errorCells2['purchaseDate'] = 'danger';
          errorCells2['productImageUrl'] = 'danger';
          errorCells2['productCondition'] = 'danger';
          errorCells2['asinSku'] = 'danger';
          errorCells2['productNameEn'] = 'danger';
          errorCells2['weightInfo'] = 'danger';
          errorCells2['janCode'] = 'danger';
          errorCells2['childProductNameJp'] = 'danger';
          errorCells2['purchaseInfo'] = 'danger';
          errorCells2['price'] = 'danger';
          errorCells2['shopName'] = 'danger';
          errorCells2['forcastShippingCost'] = 'danger';
          errorCells2['forcastTargetSales'] = 'danger';
          errorCells2['forcastTargetProfit'] = 'danger';
          errorCells2['lastPurchaseDate'] = 'danger';
          errorCells2['additionalCount'] = 'danger';
          errorCells2['inboundQuantity'] = 'danger';
          errorCells2['unInboundQuantity'] = 'danger';
          errorCells2['status'] = 'danger';
          errorCells2['comment'] = 'danger';
          errorCells2['matomeStatus'] = 'danger';
          errorCells2['setLabel'] = 'danger';
          errorCells2['update'] = 'danger';
          errorCells2['history'] = 'danger';
        }
        vv['_cellVariants'] = errorCells2;
      }
    },
    outputPastCsv(){
      api.getInboundPastData(this.memberId, (data) => {
        // バーコード印刷
        if(data.kakoFileUrl == null){
          this.confirmMessageSimple = '発送済データがありません。';
          this.$refs.messagePopupSimple.show();
          return;
        }
        let anchor = document.createElement('a');
        anchor.href = data.kakoFileUrl;
        anchor.target = '_blank';
        anchor.click();
      })
    },
    outputCsv() {
      let header = '\ufeff' + '仕入日,状態,ASIN,SKU,JANコード,商品名(英),仕入数,単価,総額,店舗名,重量(kg),見込送料,T売上,T利益,入庫日,入庫数,未受,STATUS,備考\n';
      // let ids = ['purchaseDate', 'productCondition', 'asinSku', 'janCode', 'productNameEn', 'purchaseQuantity', 'price', 'shopName', 'weightInfo', 'forcastShippingCost', 'forcastTargetSales', 'forcastTargetProfit', 'lastPurchaseDate', 'inboundQuantity', 'unInboundQuantity', 'status', 'comment'];
      let ids = ['purchaseDate', 'productCondition', 'asin', 'sku', 'janCode', 'productNameEn', 'purchaseQuantity', 'purchaseUnitPrice', 'totalAmount', 'shopName', 'weight', 'forcastShippingCost', 'forcastTargetSales', 'forcastTargetProfit', 'lastPurchaseDate', 'inboundQuantity', 'unInboundQuantity', 'status', 'comment'];
      this.outputFile(this.items, header, ids, '通常商品一覧.csv');
    },
    outputSetCsv() {
      let setHeader = '\ufeff' + '仕入日,状態,ASIN,SKU,商品名(英),重量(kg),商品コード,商品名(日),仕入数,(セット集約単位),単価,総額,店舗名,見込送料,T売上,T利益,入庫日,入庫数,未受,STATUS,備考\n';
      let setIds = ['purchaseDate', 'productCondition', 'asin', 'sku', 'productNameEn', 'weight', 'janCode', 'childProductNameJp', 'purchaseQuantity', 'childQuantityPerSet', 'purchaseUnitPrice', 'totalAmount', 'shopName', 'forcastShippingCost', 'forcastTargetSales', 'forcastTargetProfit', 'lastPurchaseDate', 'inboundQuantity', 'unInboundQuantity', 'status', 'comment'];
      this.outputFile(this.setItems, setHeader, setIds, 'セット商品一覧.csv');
    },
    outputFile(items, header, ids, fileName) {
      let csv = header;
      for (const item of items) {
        if(!item['activeRecord']) {
          continue;
        }
        csv = csv + '"';
        for (const id of ids) {
          if (item[id] == null || item[id] === '') {
            if (id === 'asinSku') {
              csv += item['asin'] + '\r\n' + item['sku'] + '","';
            } else if (id === 'weightInfo') {
              csv += item['weight'] + '","';
            } else if (id === 'purchaseInfo') {
              csv += item['purchaseQuantity'] + '\r\n' + '(' + item['childQuantityPerSet'] + ')\r\n' +'","';
            } else if (id === 'price') {
              csv += item['totalAmount'] + '\r\n' + '(' + item['purchaseUnitPrice'] + ')\r\n' +'","';
            } else {
              csv += '","';
            }
          } else {
            if (id === 'productCondition') {
              if (item[id] ==='0') {
                csv += 'NEW' + '","';
              } else if (item[id] ==='1') {
                csv += 'USED' + '","';
              } else {
                csv += item[id] + '","';
              }
            } else if (id === 'status') {
              csv += this.getStatusList(item) + '","';
            } else {
              if (isNaN(item[id])) {
                csv += item[id].replace(/"/g, '') + '","';
              } else {
                csv += item[id] + '","';
              }
            }
          }
        }
        csv = csv.substring(0, csv.length - 2);
        csv += '\n';
      }
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    getStatusList(item) {
      let statusList = '';
      // 有効なレコードの処理
      for (const v of item['status'].split(',')) {
        statusList += ReasonType.valueOf(v).text + '\r\n';
      }
      return statusList;
    },
  },
};

Vue.component('inbound-slc-analysis', InboundSlcAnalysis);
Vue.component('seller-select-modal', SellerSelectModal);
Vue.component('to-trouble-product-not-trenai', ToTroubleTrenai);
Vue.component('inbound-filter', InboundFilter);
Vue.component('inbound-table', InboundTable);
Vue.component('inbound-set-table', InboundSetTable);
Vue.component('inbound-history-modal', InboundHistoryModal);

</script>

<style>
.right-aligned {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px; /* チェックボックスとボタンの間のスペース */
  margin-top: 10px; /* モーダル内の他の要素とのスペース調整 */
}
.modal-divider {
  border: none;
  border-top: 1px solid #ccc; /* 線のスタイル */
  margin: 10px 0; /* 線の上下のマージン */
}
.component-margin {
  margin-bottom: 1rem;
}
.component-margin-half {
  margin-bottom: .5rem;
}
.text-window {
    padding: 1em;
    background-color: lightblue;
}
.label-pointer{
  cursor: pointer;
}
</style>
